import { CSSProperties } from 'react';

// 9 numbers + 2 commas
export const defaultMaxLength = 11;
export const inputStyle: CSSProperties = { fontSize: '44px', lineHeight: '56px' };
